<template>
  <div class="text-start">
    <nav class="border-b border-gray-300 px-2 mb-4  md:px-0 py-2" v-if="breadcrumb">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'bandwidth_policies'}">Bandwidth policies</router-link>
            <span class="mx-2">/</span>
            <span>{{ title || 'New bandwidth policy' }}</span>
          </div>
          <div class="text-xl">
            {{ title || 'New bandwidth policy' }}
          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white p-4 border rounded shadow-sm">
        <div class="">
          <label class="block text-sm  mb-1">Policy name<span class="text-red-700">*</span></label>
          <input aria-label="Plan name" type="text" required v-model="name" :class="inputClass"
                 placeholder="Plan name"/>
        </div>
        <div class="flex my-3 justify-between">
          <div class="w-full mr-2">
            <label class="block text-sm leading-5 font-medium text-gray-700">Upload Limit</label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input :class="inputClass" v-model="upload_max" placeholder="1">
              <div class="absolute inset-y-0 right-0 flex items-center">
                <select aria-label="Currency" v-model="upload_max_unit"
                        class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent mr-2 sm:text-sm sm:leading-5">
                  <option>Kbps</option>
                  <option>Mbps</option>
                </select>
              </div>
            </div>
          </div>
          <div class="w-full ml-2">
            <label class="block text-sm leading-5 ">Download limit</label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input v-model="download_max" type="number" :class="inputClass" placeholder="1">
              <div class="absolute inset-y-0 right-0 flex items-center">
                <select v-model="download_max_unit"
                        class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent mr-2 sm:text-sm sm:leading-5">
                  <option>Kbps</option>
                  <option>Mbps</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="my-3">
          <label class="block text-sm leading-5 mb-1">Description</label>
          <textarea v-model="description" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                    placeholder="Friendly description"></textarea>
        </div>
        <div class="mt-6">
          <button v-if="$store.getters.can( policyId != null ?'create_bandwidth_policy':'edit_bandwidth_policy')"
                  v-on:click="saveServicePlan" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
            {{ policyId != null ? 'Update' : 'Create' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "CreateBandwidthPolicy",
  components: {},
  data() {
    return {
      name: null,
      upload_max: 1,
      download_max_unit: 'Mbps',
      download_max: 1,
      upload_max_unit: 'Mbps',
      description: '',
      loading: false,
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  props: {
    title: String,
    policyId: String,
    breadcrumb: {type: Boolean, default: true}
  },
  mounted() {
    if (this.policyId != null) {
      GraphQl.sendRequest('{bandwidthPolicy(id: "' + this.policyId + '"){id name max_download max_download_unit max_upload max_upload_unit description}}')
          .then(response => {
            this.name = response.bandwidthPolicy.name;
            this.upload_max = response.bandwidthPolicy.max_upload;
            this.download_max_unit = response.bandwidthPolicy.max_download_unit;
            this.download_max = response.bandwidthPolicy.max_download;
            this.upload_max_unit = response.bandwidthPolicy.max_upload_unit;
            this.description = response.bandwidthPolicy.description;
          })
    }
  },
  methods: {
    saveServicePlan() {
      let params = 'name: "' + this.name + '", ' +
          (this.policyId != null ? 'id:"' + this.policyId + '" ' : '') +
          'max_upload: ' + this.upload_max + ',' +
          'max_upload_unit: "' + this.upload_max_unit + '",' +
          'max_download: ' + this.download_max + ', ' +
          'max_download_unit: "' + this.download_max_unit + '", ' +
          'description: "' + this.description + '", ';

      GraphQl.sendRequest('mutation{bandwidthPolicy(' + params + '){code message}}')
          .then(response => {
            alert(response.bandwidthPolicy.message);
            this.$router.push({message: 'bandwidth_policies'})
          })
    }
  }
}
</script>
<style scoped>
</style>